import { useAuthState } from '@/redux/hooks/auth';
import { useGetCartQuery } from '@/services/ecomm';

/**
 * The cart array returned from Coral/EClient keeps items and item modifiers at the same level.
 * To get the correct cart count, you must first filter out the modifiers. Then,
 * you can sum the item quantities.
 */
export const useCartCount = () => {
  const { isAuthenticated } = useAuthState();

  const cartQuery = useGetCartQuery(undefined, {
    skip: !isAuthenticated,
  });

  const cartItems = cartQuery.data?.cartItemViews;
  const filtered = cartItems?.filter((item) => item.nestLevel === 0);
  const count = filtered?.reduce((acc, curr) => acc + (curr.quantityAmount ?? 0), 0);

  return count;
};

// Usage
// const count = useCartCount()
